import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Typography } from '@mui/material'
import { useState } from 'react'
import useDebounce from 'utils/customHook/useDebounce'
import SuperMultiAutocomplete from 'components/forms/SuperMultiAutocomplete'
import HelpParameter from '../HelpParameter'

const ParameterWithSuperMultiAutocomplete = ({
    parameters = [],
    setParameters = () => {},
    getGlobalParameter = () => {},
    moduleParameters = [],
    setModuleParameters = [],
    getGlobalModuleParameter = () => {},
    cmsEvents = [],
    options = [],
    isGlobal = false,

    parameter = '',
    title = '',
    helpImage,

    description,
    iconTooltip,
    keyLabel = 'title',
    keyValue,

    multiple = false,
    limit,
}) => {
    const foundParameter = parameters.find(p => p.parameter === parameter)?.value
    const foundModuleParameter = moduleParameters.find(p => p.parameter === parameter)?.value

    const [stateParameter, setStateParameter] = useState(
        foundParameter && multiple
            ? foundParameter.split(',').map((id) => Number(id))
            : parseInt(foundParameter),
    )
    const [stateModuleParameter, setStateModuleParameter] = useState(multiple && foundModuleParameter?.split(',').map(d => parseInt(d)) || parseInt(foundModuleParameter))

    const selectedOptions = options?.length ? options : cmsEvents

    useDebounce(() => {
        setParameters(prev => [
            ...prev.filter(p => p.parameter !== parameter),
            multiple
                ? getGlobalParameter(parameter, stateParameter.join(','))
                : getGlobalParameter(parameter, stateParameter),
        ])
    }, 200, [stateParameter])

    useDebounce(() => {
        setModuleParameters(prev => [
            ...prev.filter(p => p.parameter !== parameter),
            multiple
                ? getGlobalModuleParameter(parameter, stateModuleParameter.join(','))
                : getGlobalModuleParameter(parameter, stateModuleParameter),
        ])
    }, 200, [stateModuleParameter])

    return (
        <Grid container columnSpacing={1} alignItems='center'>
            <Grid size={0.5}>
                <HelpParameter image={helpImage} />
            </Grid>
            <Grid container size='grow'>
                <Typography variant='normalFormTitle'>{title}</Typography>
                {description}
            </Grid>
            <Grid size={3.25}>
                <SuperMultiAutocomplete
                    options={selectedOptions}
                    values={stateParameter}
                    onChange={setStateParameter}
                    keyLabel={keyLabel}
                    keyValue={keyValue}
                    disabled={!isGlobal}
                    multiple={multiple}
                    limit={limit}
                />
            </Grid>
            {!isGlobal && (
                <Grid size={3.25}>
                    <SuperMultiAutocomplete
                        options={selectedOptions}
                        values={stateModuleParameter}
                        onChange={setStateModuleParameter}
                        keyLabel={keyLabel}
                        keyValue={keyValue}
                        multiple={multiple}
                        limit={limit}
                    />
                </Grid>
            )}
            <Grid size={0.5}>
                {iconTooltip}
            </Grid>
        </Grid>
    )
}

ParameterWithSuperMultiAutocomplete.propTypes = {
    parameters: PropTypes.arrayOf(PropTypes.shape({})),
    setParameters: PropTypes.func,
    getGlobalParameter: PropTypes.func,
    moduleParameters: PropTypes.arrayOf(PropTypes.shape({})),
    setModuleParameters: PropTypes.func,
    getGlobalModuleParameter: PropTypes.func,
    cmsEvents: PropTypes.arrayOf(PropTypes.shape({})),
    options: PropTypes.arrayOf(PropTypes.shape({})),
    isGlobal: PropTypes.bool,
    parameter: PropTypes.string,
    title: PropTypes.string,
    keyLabel: PropTypes.string,
    keyValue: PropTypes.string,
    helpImage: PropTypes.node,
    description: PropTypes.node,
    iconTooltip: PropTypes.node,
    multiple: PropTypes.bool,
    limit: PropTypes.number,
}

export default ParameterWithSuperMultiAutocomplete
